import { z } from 'zod'
import { runFilterSchema } from './cadence.js'

/**
 * A saved view stores the filter's *semantic intent* — `{ verdict: "refused" }`
 * — not an opaque query string (UI spec addendum §B). That's what makes the
 * next part possible: if a stored field no longer parses against the
 * current filter schema (a verdict vocabulary change is the realistic
 * case — `runVerdictSchema` is a strict enum, so an old value falls out of
 * it cleanly), the view is returned with `filter: null` and `filterValid:
 * false` rather than dropped or thrown. The frontend renders that as the
 * grayed-out note the addendum specifies, never a crash and never silence.
 */
export const savedViewSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  filter: runFilterSchema.nullable(),
  filterValid: z.boolean(),
})
export type SavedView = z.infer<typeof savedViewSchema>

export const savedViewListResponseSchema = z.object({
  views: z.array(savedViewSchema),
})

export const createSavedViewRequestSchema = z.object({
  name: z.string().min(1).max(200),
  filter: runFilterSchema,
})
export type CreateSavedViewRequest = z.infer<typeof createSavedViewRequestSchema>
